/*
  AironiMenager — comportements du panier (page et tiroir).

  1. « Livraison estimée » : dates calculées le jour de la visite (le HTML de
     Shopify est mis en cache), en jours ouvrés, depuis data-am-min/max.
  2. « Ajouter » des suggestions : ajout au panier puis mise à jour du tiroir
     (même mécanisme que Dawn) ou rechargement de la page panier.

  Dawn remplace le HTML du panier à chaque changement de quantité : tout est
  donc délégué ou relancé par un MutationObserver, jamais attaché une fois.
*/
(function () {
  function plusJoursOuvres(depart, n) {
    var d = new Date(depart);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }

  function remplirDates(racine) {
    (racine || document).querySelectorAll('.am-recap__ligne--date[hidden]').forEach(function (l) {
      var auj = new Date();
      if (auj.getDay() === 6) auj.setDate(auj.getDate() + 2);
      if (auj.getDay() === 0) auj.setDate(auj.getDate() + 1);
      var f = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
      l.querySelector('.am-recap__dates').textContent =
        'du ' + f.format(plusJoursOuvres(auj, +l.dataset.amMin)) + ' au ' + f.format(plusJoursOuvres(auj, +l.dataset.amMax));
      l.hidden = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    remplirDates();
  });
  remplirDates();

  new MutationObserver(function () {
    if (document.querySelector('.am-recap__ligne--date[hidden]')) remplirDates();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-am-ajout]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    b.classList.add('loading');
    var tiroir = document.querySelector('cart-drawer');
    var dansTiroir = tiroir && b.closest('cart-drawer');
    var corps = { items: [{ id: Number(b.dataset.amAjout), quantity: 1 }] };
    if (dansTiroir && typeof tiroir.getSectionsToRender === 'function') {
      corps.sections = tiroir.getSectionsToRender().map(function (s) { return s.id; });
      corps.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    })
      .then(function (r) { return r.json(); })
      .then(function (rep) {
        if (rep.status) throw new Error(rep.description || 'Erreur');
        if (dansTiroir && rep.sections && typeof tiroir.renderContents === 'function') {
          rep.id = rep.items && rep.items[0] ? rep.items[0].key : rep.id;
          tiroir.renderContents(rep);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        b.disabled = false;
        b.classList.remove('loading');
        window.location.href = '/cart';
      });
  });
})();
